import React from "react";
import { Button, Dialog, TextField } from "@vitalsource/vstui";
import { Translation, t } from "../../../core/translate";
import { connect } from "react-redux";
import {
  actions as userActions,
  selectors as userSelectors
} from "../../../../redux/user";
import FormAlert from "../form-alert";

class ChangeEmailDialog extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <Dialog
        formProps={{
          onSubmit: async e => {
            e.preventDefault();
            if (!this.props.isFetching) {
              const response = await this.props.setInfo({
                email: this.newEmail.value
              });
              if (response.success) {
                this.props.onClose(true);
              } else {
                if (
                  response.error &&
                  response.error.errors.email &&
                  response.error.errors.email.indexOf(
                    "email has already been taken"
                  ) !== -1
                ) {
                  this.setState({
                    emailError: t(
                      "registration.email-already-exists",
                      "An account with this email already exists."
                    )
                  });
                } else {
                  this.setState({
                    emailError: t(
                      "email-verification.error-changing-email",
                      "Update error. Try again or contact support.",
                      {
                        support: (
                          <Button
                            inline
                            href={this.props.supportUrl}
                            target="_blank"
                          >
                            <Translation id="email-verification.contact-support">
                              Contact support
                            </Translation>
                          </Button>
                        )
                      }
                    )
                  });
                }
              }
            }
          }
        }}
        onRequestClose={this.props.onClose}
        open
        primaryActionButton={{
          label: t("base.ok", "Ok")
        }}
        secondaryActionButton={{
          label: t("base.cancel", "Cancel"),
          onClick: this.props.onClose
        }}
        title={t("registration.update-your-email", "Update your email")}
      >
        {this.state.emailError && (
          <FormAlert level="error" key={`error-${this.state.emailError}`}>
            {this.state.emailError}
          </FormAlert>
        )}
        <TextField
          fullWidth
          label={t("base.email", "Email")}
          type="email"
          nativeFormControlRef={x => (this.newEmail = x)}
          defaultValue={this.props.defaultEmail}
          required
        />
        <TextField
          fullWidth
          label={t("base.confirm-email", "Confirm Email")}
          type="email"
          nativeFormControlRef={x => (this.newEmailConfirmation = x)}
          validate={() => {
            if (this.newEmail.value !== this.newEmailConfirmation.value) {
              return t("registration.email-no-match", "Emails must match");
            }
          }}
          required
        />
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: userSelectors.isUserFetching(state)
});

const mapDispatchToProps = dispatch => ({
  setInfo: info => dispatch(userActions.setInfo(info))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeEmailDialog);
